import { lotSize } from 'global/TradingModal/constant';
import { RunningTradeCustomFilter, RunningTradeStockFilter, RunningTradeCustomFilterActionEnum, StockFilterTypeEnum } from './types';

type ActionTypeMap = {
  [key: number]: RunningTradeParamsActionType;
};

const actionTypeMap: ActionTypeMap = {
  0: 'ACTION_TYPE_ALL',
  1: 'ACTION_TYPE_BUY',
  2: 'ACTION_TYPE_SELL',
};

export const isNumber = (value: any): boolean => {
  if (value === null || typeof value === 'undefined') return false;
  const newN = Number(value);
  return !Number.isNaN(newN);
};

export const mapCustomFilter =
  (filter: RunningTradeCustomFilter & RunningTradeStockFilter, isOpenMarket: boolean) => {
  const mappedFilter: GetInitRunningTradeParamsV2 = {};

  if (
    filter?.type === StockFilterTypeEnum.Custom
    && !isOpenMarket
    && filter.selected.length === 1
  ) {
    mappedFilter.symbols = filter?.selected[0].split('#')[0];
  }

  if (mappedFilter.symbols && actionTypeMap[filter?.actionType]) {
    mappedFilter.action_type = actionTypeMap[filter?.actionType];
  }

  if (mappedFilter.symbols && isNumber(filter?.minPrice)) {
    mappedFilter.price_range_from = filter.minPrice;
  }

  if (mappedFilter.symbols && isNumber(filter?.maxPrice)) {
    mappedFilter.price_range_to = filter.maxPrice;
  }

  // Uncomment if watchlist_id has been implemented on BE
  // if (isNumber(filter?.minPercentage)) {
  //   mappedFilter.price_change_from = filter.minPercentage;
  // }

  // Uncomment if watchlist_id has been implemented on BE
  // if (isNumber(filter?.maxPercentage)) {
  //   mappedFilter.price_change_to = filter.maxPercentage;
  // }

  if (mappedFilter.symbols && isNumber(filter?.minLot)) {
    mappedFilter.minimum_lot = filter.minLot;
  }

  if (mappedFilter.symbols && filter.timeRangeStart) {
    mappedFilter['time_range.start'] = filter.timeRangeStart;
  }

  if (mappedFilter.symbols && filter.timeRangeEnd) {
    mappedFilter['time_range.end'] = filter.timeRangeEnd;
  }

  // Uncomment if watchlist_id has been implemented on BE
  // if (filter?.type === StockFilterTypeEnum.Watchlist && !isOpenMarket) {
  //   mappedFilter.watchlist_id = parseInt(`${filter?.watchlistId}`, 10);
  // }

  return mappedFilter;
};

const parseNumberFilter = (type: 'min' | 'max', value?: number) => {
  if (isNumber(value)) {
    return value;
  }
    if (type === 'min') {
      return Number.MIN_SAFE_INTEGER;
    }
    return Number.MAX_SAFE_INTEGER;
};

export const filterRunningTrade = (
  items: RunningTradeItem[],
  filter: RunningTradeCustomFilter,
  stockFilter: RunningTradeStockFilter,
) => items.filter((item) => {
    const isCustomOrWatchlist =
      stockFilter?.type === StockFilterTypeEnum.Custom ||
      stockFilter?.type === StockFilterTypeEnum.Watchlist;

    if (isCustomOrWatchlist && // only filter on custom/watchlist type
      stockFilter?.selected?.length > 0 && // only filter if selected stock more than 0
      !stockFilter.selected.map((symbol) => symbol.split('#')[0]).includes(item.stock) // check if stock is not on selected symbol
    ) {
      return false;
    }

    let [
      isMatchingAction,
      isWithinMinPrice,
      isWithinMaxPrice,
      meetsMinPercentage,
      meetsMaxPercentage,
      meetsMinLot,
    ] = Array(6).fill(false);

    if (!filter) {
      isMatchingAction = true;
    } else if (filter?.actionType === RunningTradeCustomFilterActionEnum.ALL) {
      isMatchingAction = true;
    } else if (
      item.action === filter?.actionType
    ) {
      isMatchingAction = true;
    }

    if (item.price >= parseNumberFilter('min', filter?.minPrice)) {
      isWithinMinPrice = true;
    }

    if (item.price <= parseNumberFilter('max', filter?.maxPrice)) {
      isWithinMaxPrice = true;
    }

    if (Math.floor(item.change.percentage * 100) / 100 >= parseNumberFilter('min', filter?.minPercentage)) {
      meetsMinPercentage = true;
    }

    if (Math.floor(item.change.percentage * 100) / 100 <= parseNumberFilter('max', filter?.maxPercentage)) {
      meetsMaxPercentage = true;
    }

    if (item.volume / lotSize >= parseNumberFilter('min', filter?.minLot)) {
      meetsMinLot = true;
    }

    return isMatchingAction
      && isWithinMinPrice
      && isWithinMaxPrice
      && meetsMinPercentage
      && meetsMaxPercentage
      && meetsMinLot;
  });
